<template>
  <i
    :class="[ns.b(), ns.is('loading', loading)]"
    :style="style"
    v-bind="$attrs"
    data-test-name="icon"
    data-test-variant=""
    data-test-state=""
  >
    <slot />
  </i>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { addUnit, isUndefined } from '@bigin/utils'
import { useNamespace } from '@bigin/hooks'
import { iconProps } from './icon'
import type { CSSProperties } from 'vue'

defineOptions({
  name: 'BIcon',
  inheritAttrs: false,
})
const props = defineProps(iconProps)
const ns = useNamespace('icon')

const style = computed<CSSProperties>(() => {
  const { size, color } = props
  if (!size && !color) return {}

  return {
    fontSize: isUndefined(size) ? undefined : addUnit(size),
    '--color': color,
  }
})
</script>
